import { render, staticRenderFns } from "./digitalizar_encuesta.vue?vue&type=template&id=4dbcff0e&scoped=true"
import script from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
export * from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
import style0 from "./digitalizar_encuesta.vue?vue&type=style&index=0&id=4dbcff0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcff0e",
  null
  
)

export default component.exports